var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95354 0.682364L15.6233 6.25996C16.5589 7.18045 16.5708 8.68468 15.6513 9.6203L10.0728 15.2904C9.15242 16.2258 7.64791 16.238 6.71247 15.3176L1.04267 9.73962C0.107194 8.81922 0.0950233 7.31476 1.01537 6.37933L6.59311 0.709633C7.51354 -0.225822 9.01809 -0.237968 9.95354 0.682364ZM8.33301 3.33295C8.85281 3.33295 9.27419 3.75433 9.27419 4.27413V8.98001C9.27419 9.49981 8.85281 9.92119 8.33301 9.92119C7.81321 9.92119 7.39183 9.49981 7.39183 8.98001V4.27413C7.39183 3.75433 7.81321 3.33295 8.33301 3.33295ZM9.27419 11.7647C9.27419 12.2845 8.85281 12.7059 8.33301 12.7059C7.81321 12.7059 7.39183 12.2845 7.39183 11.7647C7.39183 11.2449 7.81321 10.8235 8.33301 10.8235C8.85281 10.8235 9.27419 11.2449 9.27419 11.7647Z",
    fill: "#F40000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.b7e4a1d4c0aa2abcd0b5b1441feca871.svg";
export { ForwardRef as ReactComponent };